import { useQuery } from '@apollo/client';
import { transformError } from '@core/adapters/errors/transformError';
import { useMemo } from 'react';

import { GET_SYSTEM_CONFIG } from '../graphql/queries/getSystemConfig';

interface SystemConfigResponse {
  systemConfig: {
    mediaServiceUrl?: string;
  };
}

/**
 * Hook for fetching system-wide configuration
 * Provides access to system-level settings like mediaServiceUrl
 */
export function useSystemConfig() {
  const { data, loading, error, refetch } = useQuery<SystemConfigResponse>(GET_SYSTEM_CONFIG, {
    fetchPolicy: 'cache-first', // System config rarely changes, so prefer cache
    errorPolicy: 'all',
  });

  // Transform error using adapter pattern
  const domainError = useMemo(() => {
    if (!error) return undefined;

    const mappedError = transformError(error);

    return {
      ...mappedError,
      onRetry: () => refetch(),
    };
  }, [error, refetch]);

  return {
    mediaServiceUrl: data?.systemConfig?.mediaServiceUrl,
    loading,
    error: domainError,
    refetch,
  };
}
